import { DwellingType } from '__generated__/athena/graphql';
import type { MarketplaceDwellingType } from '__generated__/zeus/types';

const dwellingType = {
  CONDO: DwellingType.APARTMENT,
  HOUSE: DwellingType.SINGLE_FAMILY,
  MULTI_FAMILY: DwellingType.MULTI_FAMILY,
  OTHER: DwellingType.OTHER,
  TOWNHOUSE: DwellingType.TOWNHOUSE,
} satisfies Record<MarketplaceDwellingType, DwellingType>;

export const toDwellingType = (value: MarketplaceDwellingType): DwellingType => dwellingType[value];
